import {
  Action,
  ActionEvent,
  InputType
} from "@projectstorm/react-canvas-core";
import { commonsStore, PopupMessage } from "lego-gui-lib";
import { t } from "../../core/i18n/i18n";
import { isEqual } from "lodash";

interface CustomDeleteItemsActionOptions {
  keyCodes?: number[];
  modifiers?: {
    ctrlKey?: boolean;
    shiftKey?: boolean;
    altKey?: boolean;
    metaKey?: boolean;
  };
}

/**
 * Deletes all selected items, but asks for confirmation first
 */
export class CustomDeleteItemsAction extends Action {
  public constructor(options: CustomDeleteItemsActionOptions = {}) {
    const keyCodes = options.keyCodes || [46, 8];
    const modifiers = {
      ctrlKey: false,
      shiftKey: false,
      altKey: false,
      metaKey: false,
      ...options.modifiers
    };
    super({
      type: InputType.KEY_DOWN,
      // @ts-ignore
      fire: (event: ActionEvent<React.KeyboardEvent>) => {
        const { keyCode, ctrlKey, shiftKey, altKey, metaKey } = event.event;
        if (
          keyCodes?.indexOf(keyCode) !== -1 &&
          isEqual({ ctrlKey, shiftKey, altKey, metaKey }, modifiers)
        ) {
          const selectedEntities = this.engine.getModel().getSelectedEntities();
          if (selectedEntities.length > 0) {
            const deleteOneTitle = t("lego:views.show.confirmDelete.title")();
            const deleteOneContent = t(
              "lego:views.show.confirmDelete.content"
            )();
            const dialogMessage: PopupMessage = {
              title: deleteOneTitle,
              content: deleteOneContent
            };
            commonsStore.showDialog(dialogMessage, () => {
              selectedEntities.forEach(model => {
                // only delete items which are not locked
                if (!model.isLocked()) {
                  model.remove();
                }
              });
              commonsStore.closeDialog();
            });
          }
        }
      }
    });
  }
}
